/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * ERP API
 * 날짜·요일·시간 요청 및 응답은 UTC 기준입니다. 시간대 없는 date/time/date-time 값도 UTC로 해석하며 서버에서 KST로 변환하지 않습니다. 프런트에서 시간대를 변환할 때 날짜와 요일도 함께 변환해야 합니다. 날짜 검색의 from/to는 UTC 시작 포함·종료 미포함입니다. time_zone을 지원하는 조회의 날짜 그룹은 해당 시간대를 따릅니다. 생일 등 날짜 자체를 의미하는 값은 입력한 날짜를 그대로 사용합니다.
 * OpenAPI spec version: v1
 */
import type {
  BaseResponseAcademyZoomResponse,
  BaseResponseDeleteZoomMeetingsResponse,
  BaseResponseListZoomEventResponse,
  BaseResponseVoid,
  BaseResponseZoomAuthorizationResponse,
  BaseResponseZoomConnectionResponse,
  BaseResponseZoomCreationOptionsResponse,
  BaseResponseZoomMeetingDetailResponse,
  BaseResponseZoomMeetingResponse,
  BaseResponseZoomMeetingStartResponse,
  BindZoomLessonSessionRequest,
  BindZoomLessonSessionsRequest,
  Callback200,
  CallbackParams,
  CompleteZoomRequest,
  CreateZoomMeetingRequest,
  DeleteZoomMeetingsRequest,
  EventsParams,
  ReprocessAttendanceParams,
  ZoomWebhookResponse,
} from '.././models';

import { customInstance } from '../../../../shared/apiClient/orvalMutator';

export const getZoom = () => {
  /**
 * lesson_session_ids로 1~200개 회차를 전달. 수업 공용 회의(lesson_id 설정)는 별도 회차 연결 불가(BAD_REQUEST). 모든 회차의 학원 활성 구성원이며 회의 생성자여야 함(FORBIDDEN). 기존 연결 유지, 중복 멱등, 전체 검증 후 원자적으로 추가. ZOOM_MEETING_NOT_FOUND, LESSON_SESSION_NOT_FOUND, LESSON_NOT_FOUND 가능. 과거 이벤트는 attendance/reprocess로 별도 재처리. 매핑 정책: lesson_id가 있으면 해당 수업의 기존/추가 회차를 자동 조회. 그렇지 않으면 명시적으로 연결된 회차를 조회. 하나의 회의를 여러 회차에 연결 가능. 이벤트 발생 시각(UTC)이 시작 30분 전~종료(양끝 포함)에 속하는 회차를 선택.
연속 회차의 사전 입장 구간이 겹치면 현재 진행 중인 회차를 선택한다. 그 외 유효 후보가 여러 개면 AMBIGUOUS_SESSION으로 보존하고 출결을 변경하지 않는다(학생 등록으로 임의 선택하지 않음).
미연결은 SESSION_NOT_LINKED, 유효 회차 없음은 SESSION_UNAVAILABLE, 시간 후보 없음은 OUTSIDE_SESSION_WINDOW.
선택된 회차의 유효 수강 등록만 대상(등록 REGISTERED, 수강 PENDING/ACTIVE, 회차 CANCELED/HOLD 제외).
입퇴장 참가자 ID가 회의 소유자 ID와 같으면 HOST_PARTICIPANT, 연결 수업 학원의 활성 관리자/직원 또는 담당 강사의 Zoom 연동 ID와 같으면 STAFF_PARTICIPANT로 분류하고 학생 출석에서 제외합니다. 원본 이벤트는 유지하며 완료 분류는 재처리하지 않습니다.
registrant_id가 있으면 학생별 등록 정보를 우선하며 미등록 ID는 대체 매칭하지 않는다. 없으면 participant_user_id와 해당 학원 zoom_id_memo를 완전 일치시킨다.
외부 계정 연동/participant_id/participant_uuid/이름/이메일로 대체 매칭하지 않는다. 메모 후보가 여러 명이면 AMBIGUOUS_STUDENT.
PENDING=미처리, UNSUPPORTED_EVENT=회의 시작/종료, SESSION_NOT_LINKED=수업/회차 미연결, SESSION_UNAVAILABLE=삭제/취소/보류/시간 누락,
MISSING_ZOOM_ID=ID 누락, STUDENT_NOT_FOUND=검증 계정 학생 없음, AMBIGUOUS_STUDENT=학생 다수,
REGISTRATION_NOT_FOUND=유효 수강 없음, AMBIGUOUS_REGISTRATION=등록 다수. 실패해도 원본을 보존하며 Webhook은 204.
is_join_leave_recorded=true이면 상세 입퇴장을 기록한다. false여도 출결 변경 근거 및 재처리용 웹훅 기록은 유지하고 퇴장/재입장 상세 이력은 생략한다.
종료 시각이 시작 이하이면 다음날 종료로 본다. 범위 밖은 OUTSIDE_SESSION_WINDOW.
입장 시각이 [시작-30분, 종료]일 때 미처리 출결 판정: 시작+10분까지 ATTEND, 10분 초과~30분까지 LATE, 30분 초과부터 ABSENT.
같은 학생/학원에서 바로 앞 유효 수강 회차의 종료가 현재 시작과 같으면 30분 초과도 ATTEND. 출결 시각은 UTC 저장.
기존 QR/수동 출결은 보존한다. 스케줄러 결석은 연속 뒤 회차의 30분 초과 입장 예외에 한해 출석으로 보정한다. APPLIED=출결 판정 반영, RECORDED=이력만 기록(상태 after=null).
퇴장만으로 조퇴/결석을 판정하지 않는다. 재입장은 별도 이력이며 최초 유효 입장을 유지한다.
역순 수신은 더 이른 유효 입장이 오면 기존 Zoom 판정만 보정한다. 퇴장 선수신도 이력을 남기고 입장 수신 시 판정한다.
최초 유효 출석·지각 반영 시 기존 자동 알림 유형의 enabled 및 STUDENT/PARENT 선택에 따라 학생·학부모 개인 온라인 등원 알림을 생성한다. 상세 입퇴장 기록 설정과 무관하다. 재입장·퇴장·증거 전용 이벤트·이미 알린 출석/지각의 역순 보정은 추가 발송하지 않는다. 알림 저장 실패는 출결·원본 이벤트와 함께 롤백한다.
원문 동일 재전송은 원본 중복 제거. 본문이 달라도 ERP 회의 ID+회의 UUID+Zoom 계정 ID+이벤트 종류+발생 시각이 같으면
DUPLICATE로 출결 이벤트를 추가하지 않는다(같은 시각의 다중 기기도 하나). 회의/수강 행 잠금과 외부 이벤트 키 UNIQUE로 중복 방지.

 * @summary Zoom 회의에 여러 수업 회차 추가 연결
 */
  const bindLessonSessions = (id: number, bindZoomLessonSessionsRequest: BindZoomLessonSessionsRequest) => {
    return customInstance<BaseResponseVoid>({
      url: `/api/integrations/zoom/meetings/${id}/lesson-sessions`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: bindZoomLessonSessionsRequest,
    });
  };
  /**
   * 회의 생성자이며 해당 학원 활성 구성원인 사용자만 가능(FORBIDDEN). 수업 공용 회의(lesson_id 설정)는 별도 회차 연결 불가(BAD_REQUEST). 회의 하나에 여러 회차를 추가 연결할 수 있으며 같은 연결은 멱등. 기존 연결은 유지. ZOOM_MEETING_NOT_FOUND, LESSON_SESSION_NOT_FOUND, LESSON_NOT_FOUND 가능. 신규 Webhook부터 자동 반영하며 기존 원본은 attendance/reprocess로 처리. 회의 조회의 lesson_session_ids로 전체 연결 확인. lesson_session_id는 하위 호환용 최초 연결 회차.
   * @summary Zoom 회의와 수업 회차 연결
   */
  const bindLessonSession = (id: number, bindZoomLessonSessionRequest: BindZoomLessonSessionRequest) => {
    return customInstance<BaseResponseVoid>({
      url: `/api/integrations/zoom/meetings/${id}/lesson-session`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: bindZoomLessonSessionRequest,
    });
  };
  /**
 * ERP JWT 없이 원본 본문 HMAC과 5분 이내 요청 시각 검증. ZOOM_INVALID_WEBHOOK: 401. 검증 요청은 Zoom 규격 camelCase JSON, 일반 이벤트는 204. ERP에서 생성한 회의만 저장. 매핑 정책: lesson_id가 있으면 해당 수업의 기존/추가 회차를 자동 조회. 그렇지 않으면 명시적으로 연결된 회차를 조회. 하나의 회의를 여러 회차에 연결 가능. 이벤트 발생 시각(UTC)이 시작 30분 전~종료(양끝 포함)에 속하는 회차를 선택.
연속 회차의 사전 입장 구간이 겹치면 현재 진행 중인 회차를 선택한다. 그 외 유효 후보가 여러 개면 AMBIGUOUS_SESSION으로 보존하고 출결을 변경하지 않는다(학생 등록으로 임의 선택하지 않음).
미연결은 SESSION_NOT_LINKED, 유효 회차 없음은 SESSION_UNAVAILABLE, 시간 후보 없음은 OUTSIDE_SESSION_WINDOW.
선택된 회차의 유효 수강 등록만 대상(등록 REGISTERED, 수강 PENDING/ACTIVE, 회차 CANCELED/HOLD 제외).
입퇴장 참가자 ID가 회의 소유자 ID와 같으면 HOST_PARTICIPANT, 연결 수업 학원의 활성 관리자/직원 또는 담당 강사의 Zoom 연동 ID와 같으면 STAFF_PARTICIPANT로 분류하고 학생 출석에서 제외합니다. 원본 이벤트는 유지하며 완료 분류는 재처리하지 않습니다.
registrant_id가 있으면 학생별 등록 정보를 우선하며 미등록 ID는 대체 매칭하지 않는다. 없으면 participant_user_id와 해당 학원 zoom_id_memo를 완전 일치시킨다.
외부 계정 연동/participant_id/participant_uuid/이름/이메일로 대체 매칭하지 않는다. 메모 후보가 여러 명이면 AMBIGUOUS_STUDENT.
PENDING=미처리, UNSUPPORTED_EVENT=회의 시작/종료, SESSION_NOT_LINKED=수업/회차 미연결, SESSION_UNAVAILABLE=삭제/취소/보류/시간 누락,
MISSING_ZOOM_ID=ID 누락, STUDENT_NOT_FOUND=검증 계정 학생 없음, AMBIGUOUS_STUDENT=학생 다수,
REGISTRATION_NOT_FOUND=유효 수강 없음, AMBIGUOUS_REGISTRATION=등록 다수. 실패해도 원본을 보존하며 Webhook은 204.
is_join_leave_recorded=true이면 상세 입퇴장을 기록한다. false여도 출결 변경 근거 및 재처리용 웹훅 기록은 유지하고 퇴장/재입장 상세 이력은 생략한다.
종료 시각이 시작 이하이면 다음날 종료로 본다. 범위 밖은 OUTSIDE_SESSION_WINDOW.
입장 시각이 [시작-30분, 종료]일 때 미처리 출결 판정: 시작+10분까지 ATTEND, 10분 초과~30분까지 LATE, 30분 초과부터 ABSENT.
같은 학생/학원에서 바로 앞 유효 수강 회차의 종료가 현재 시작과 같으면 30분 초과도 ATTEND. 출결 시각은 UTC 저장.
기존 QR/수동 출결은 보존한다. 스케줄러 결석은 연속 뒤 회차의 30분 초과 입장 예외에 한해 출석으로 보정한다. APPLIED=출결 판정 반영, RECORDED=이력만 기록(상태 after=null).
퇴장만으로 조퇴/결석을 판정하지 않는다. 재입장은 별도 이력이며 최초 유효 입장을 유지한다.
역순 수신은 더 이른 유효 입장이 오면 기존 Zoom 판정만 보정한다. 퇴장 선수신도 이력을 남기고 입장 수신 시 판정한다.
최초 유효 출석·지각 반영 시 기존 자동 알림 유형의 enabled 및 STUDENT/PARENT 선택에 따라 학생·학부모 개인 온라인 등원 알림을 생성한다. 상세 입퇴장 기록 설정과 무관하다. 재입장·퇴장·증거 전용 이벤트·이미 알린 출석/지각의 역순 보정은 추가 발송하지 않는다. 알림 저장 실패는 출결·원본 이벤트와 함께 롤백한다.
원문 동일 재전송은 원본 중복 제거. 본문이 달라도 ERP 회의 ID+회의 UUID+Zoom 계정 ID+이벤트 종류+발생 시각이 같으면
DUPLICATE로 출결 이벤트를 추가하지 않는다(같은 시각의 다중 기기도 하나). 회의/수강 행 잠금과 외부 이벤트 키 UNIQUE로 중복 방지.

 * @summary Zoom Webhook
 */
  const receive = (receiveBody: string) => {
    return customInstance<ZoomWebhookResponse | void>({
      url: `/api/integrations/zoom/webhook`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: receiveBody,
    });
  };
  /**
   * 시작한 사용자의 ERP JWT와 completion_key 필수. 콜백 수신 후 즉시 호출합니다. 미수신이면 409 ZOOM_AUTHORIZATION_PENDING(같은 키로 재시도 가능). 만료/다른 사용자/소비된 키는 ZOOM_INVALID_STATE. 사용자 거절은 ZOOM_AUTHORIZATION_FAILED. 콜백 수신 후 완료 시도는 한 번만 가능하며 외부 통신 실패/계정 충돌 시에도 처음부터 재시작해야 합니다. 쿠키 불필요.
   * @summary Zoom 연결 완료
   */
  const complete = (completeZoomRequest: CompleteZoomRequest) => {
    return customInstance<BaseResponseZoomConnectionResponse>({
      url: `/api/integrations/zoom/oauth/complete`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: completeZoomRequest,
    });
  };
  /**
   * ERP JWT 필수. 웹/앱 공통으로 쿠키 없이 사용. authorization_url로 이동하고 completion_key는 클라이언트에만 보관하며 URL/딥링크에 넣지 않습니다. expires_in=600초. 콜백 수신 후 /oauth/complete를 호출해야 연결됩니다. ZOOM_CONFIGURATION_ERROR: 환경 설정 누락.
   * @summary Zoom 연결 URL 발급
   */
  const authorize = () => {
    return customInstance<BaseResponseZoomAuthorizationResponse>({ url: `/api/integrations/zoom/oauth/authorize`, method: 'POST' });
  };
  /**
   * start_time은 UTC ISO-8601 미래 시각. meeting_type은 2(기본 일반), 3(시간 미지정 반복), 8(시간 지정 반복). 8은 recurrence 필수이며 다른 타입은 recurrence 금지(VALIDATION_ERROR 400). agenda/password/settings는 선택. 생성 전 creation-options로 허용 조건을 확인합니다. attendance_mode 생략은 LINK_CLICK입니다. is_join_leave_recorded는 라이선스와 무관하게 선택 가능합니다. 생략은 false이며 false는 상세 입퇴장 이력만 생략합니다. 출결 결과와 처리용 웹훅 기록은 유지됩니다. ZOOM_JOIN은 유료·PMI 미사용 유형 2/8, approval_type=0, meeting_authentication=false, 반복은 registration_type=1이어야 합니다. 생성 시 라이선스·조합을 재검증하며 값은 임의 변경하지 않습니다. 조합 오류는 ZOOM_INVALID_MEETING_OPTIONS(400), 라이선스 조회 실패는 ZOOM_API_ERROR입니다. audio=both, AI 자동 시작/녹화 채널 자동 추가/지역 제한 비활성. 내 노트 참가자 트랜스크립션 범위는 공개 회의 생성 명세에 지원 필드가 확인되지 않아 Zoom 사용자 설정에서 모든 참가자 허용 확인 필요. 자세한 필드와 예시는 docs/zoom-meeting-create.md 참고. use_pmi 생략 시 false를 전달합니다. 수업/회차 연결 회의도 use_pmi=true를 허용합니다. 생성 ID와 별도로 PMI를 저장하고 Webhook은 PMI+호스트+연결 수업 시간으로 매칭합니다. 여러 회의가 겹치면 AMBIGUOUS_MEETING으로 원본만 보존하며 출결은 변경하지 않습니다. false로 요청해도 Zoom 생성 응답에서 PMI 사용이 확인되면 같은 오류를 반환하며 ERP에 저장하지 않습니다. 이 경우 Zoom에 회의가 생성됐을 수 있으므로 확인 후 재시도합니다. lesson_session_id 지정 시 회차용, lesson_id 지정 시 수업 공용으로 생성과 동시에 자동 연결. 두 필드를 동시에 지정하면 BAD_REQUEST(400). 수업 공용은 기존 및 나중에 추가되는 회차를 자동으로 출결 대상에 포함하며 별도 회차 연결이 필요 없음. 둘 다 미전달/null이면 기존처럼 미연결 회의 생성. 회차 및 학원 활성 구성원 권한은 Zoom 호출 전에 검증하며 LESSON_SESSION_NOT_FOUND, LESSON_NOT_FOUND, FORBIDDEN 가능. 출결 판정 시간은 연결된 회차의 UTC 일정을 따르며 요청한 회의 시작/길이는 자동 변경하지 않음. ZOOM_NOT_CONNECTED, ZOOM_AUTHORIZATION_FAILED(재연결 필요), ZOOM_API_ERROR 가능. 외부 API 타임아웃 시 자동 재시도 금지: Zoom에 생성됐을 수 있음.
   * @summary 본인 명의 Zoom 회의 생성
   */
  const create = (createZoomMeetingRequest: CreateZoomMeetingRequest) => {
    return customInstance<BaseResponseZoomMeetingResponse>({
      url: `/api/integrations/zoom/meetings`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createZoomMeetingRequest,
    });
  };
  /**
 * ids는 Zoom 회의 번호가 아닌 ERP 회의 ID 목록(1~100개, 각 원소 양수/필수)입니다. 중복 ID는 최초 순서대로 한 번만 처리합니다.
각 회의는 기존 단건 삭제와 동일하게 본인 소유 및 현재 연결된 Zoom 계정을 검증합니다.
Zoom 회의 전체 삭제 성공 또는 이미 없음(404/3001)이 확인되면 ERP에서 soft delete합니다.
반복 회의도 전체 삭제하며 기존 출결/이벤트는 보존합니다. 여러 ID는 순차 처리하고 회의별로 별도 트랜잭션을 완료합니다.
전체 원자적 삭제가 아니며 일부 실패해도 성공한 회의는 삭제 상태를 유지합니다.
200 data.results에서 id/deleted/error_code/message와 deleted_count/failed_count를 확인합니다.
개별 실패 코드는 ZOOM_MEETING_NOT_FOUND, FORBIDDEN, ZOOM_NOT_CONNECTED, ZOOM_AUTHORIZATION_FAILED, ZOOM_API_ERROR입니다.
예상하지 못한 서버/DB 오류는 전체 요청 500으로 반환될 수 있으며 그 전 성공한 삭제는 유지됩니다.
요청 검증 실패는 400 VALIDATION_ERROR입니다. 실패한 ID만 재요청할 수 있으며 이미 삭제된 ERP ID는 ZOOM_MEETING_NOT_FOUND입니다.

 * @summary 본인이 생성한 Zoom 회의 일괄 삭제
 */
  const deleteMeetings = (deleteZoomMeetingsRequest: DeleteZoomMeetingsRequest) => {
    return customInstance<BaseResponseDeleteZoomMeetingsResponse>({
      url: `/api/integrations/zoom/meetings`,
      method: 'DELETE',
      headers: { 'Content-Type': 'application/json' },
      data: deleteZoomMeetingsRequest,
    });
  };
  /**
   * 회의 생성자만 Zoom의 최신 설정을 조회해 DB 스냅샷을 갱신합니다. 출석 방식과 ERP 수업 일정은 변경하지 않습니다.
   * @summary Zoom 회의 설정 동기화
   */
  const sync = (id: number) => {
    return customInstance<BaseResponseZoomMeetingDetailResponse>({ url: `/api/integrations/zoom/meetings/${id}/sync`, method: 'POST' });
  };
  /**
   * 회의 생성자 또는 연결 수업의 활성 담당 강사에게 소유자 호스트 권한의 최신 start_url을 반환합니다. 저장하거나 공유하지 않고 즉시 접속에 사용합니다. 링크 발급 자체로 회의가 시작되지는 않습니다. 양수 위반: VALIDATION_ERROR, 접근/연결 계정 불일치: FORBIDDEN, 회의 없음: ZOOM_MEETING_NOT_FOUND, 연동 없음: ZOOM_NOT_CONNECTED, Zoom 인증 실패: ZOOM_AUTHORIZATION_FAILED, 조회 실패: ZOOM_API_ERROR.
   * @summary Zoom 회의 시작 링크 발급
   */
  const start = (id: number) => {
    return customInstance<BaseResponseZoomMeetingStartResponse>({ url: `/api/integrations/zoom/meetings/${id}/start`, method: 'POST' });
  };
  /**
 * 회의 생성자 및 회차 학원 활성 구성원만 가능(FORBIDDEN). ZOOM_MEETING_NOT_FOUND, LESSON_SESSION_NOT_FOUND, LESSON_NOT_FOUND, ZOOM_SESSION_NOT_LINKED(400) 가능. ERP ID 오름차순 최대 200건, 다음 after_id는 반환 마지막 ID, 빈 배열까지 반복. 계정 연결/수강 등록 보완 후 after_id=0부터 실패 항목 재시도 가능. APPLIED/RECORDED/DUPLICATE는 재처리하지 않음. 매핑 정책: lesson_id가 있으면 해당 수업의 기존/추가 회차를 자동 조회. 그렇지 않으면 명시적으로 연결된 회차를 조회. 하나의 회의를 여러 회차에 연결 가능. 이벤트 발생 시각(UTC)이 시작 30분 전~종료(양끝 포함)에 속하는 회차를 선택.
연속 회차의 사전 입장 구간이 겹치면 현재 진행 중인 회차를 선택한다. 그 외 유효 후보가 여러 개면 AMBIGUOUS_SESSION으로 보존하고 출결을 변경하지 않는다(학생 등록으로 임의 선택하지 않음).
미연결은 SESSION_NOT_LINKED, 유효 회차 없음은 SESSION_UNAVAILABLE, 시간 후보 없음은 OUTSIDE_SESSION_WINDOW.
선택된 회차의 유효 수강 등록만 대상(등록 REGISTERED, 수강 PENDING/ACTIVE, 회차 CANCELED/HOLD 제외).
입퇴장 참가자 ID가 회의 소유자 ID와 같으면 HOST_PARTICIPANT, 연결 수업 학원의 활성 관리자/직원 또는 담당 강사의 Zoom 연동 ID와 같으면 STAFF_PARTICIPANT로 분류하고 학생 출석에서 제외합니다. 원본 이벤트는 유지하며 완료 분류는 재처리하지 않습니다.
registrant_id가 있으면 학생별 등록 정보를 우선하며 미등록 ID는 대체 매칭하지 않는다. 없으면 participant_user_id와 해당 학원 zoom_id_memo를 완전 일치시킨다.
외부 계정 연동/participant_id/participant_uuid/이름/이메일로 대체 매칭하지 않는다. 메모 후보가 여러 명이면 AMBIGUOUS_STUDENT.
PENDING=미처리, UNSUPPORTED_EVENT=회의 시작/종료, SESSION_NOT_LINKED=수업/회차 미연결, SESSION_UNAVAILABLE=삭제/취소/보류/시간 누락,
MISSING_ZOOM_ID=ID 누락, STUDENT_NOT_FOUND=검증 계정 학생 없음, AMBIGUOUS_STUDENT=학생 다수,
REGISTRATION_NOT_FOUND=유효 수강 없음, AMBIGUOUS_REGISTRATION=등록 다수. 실패해도 원본을 보존하며 Webhook은 204.
is_join_leave_recorded=true이면 상세 입퇴장을 기록한다. false여도 출결 변경 근거 및 재처리용 웹훅 기록은 유지하고 퇴장/재입장 상세 이력은 생략한다.
종료 시각이 시작 이하이면 다음날 종료로 본다. 범위 밖은 OUTSIDE_SESSION_WINDOW.
입장 시각이 [시작-30분, 종료]일 때 미처리 출결 판정: 시작+10분까지 ATTEND, 10분 초과~30분까지 LATE, 30분 초과부터 ABSENT.
같은 학생/학원에서 바로 앞 유효 수강 회차의 종료가 현재 시작과 같으면 30분 초과도 ATTEND. 출결 시각은 UTC 저장.
기존 QR/수동 출결은 보존한다. 스케줄러 결석은 연속 뒤 회차의 30분 초과 입장 예외에 한해 출석으로 보정한다. APPLIED=출결 판정 반영, RECORDED=이력만 기록(상태 after=null).
퇴장만으로 조퇴/결석을 판정하지 않는다. 재입장은 별도 이력이며 최초 유효 입장을 유지한다.
역순 수신은 더 이른 유효 입장이 오면 기존 Zoom 판정만 보정한다. 퇴장 선수신도 이력을 남기고 입장 수신 시 판정한다.
최초 유효 출석·지각 반영 시 기존 자동 알림 유형의 enabled 및 STUDENT/PARENT 선택에 따라 학생·학부모 개인 온라인 등원 알림을 생성한다. 상세 입퇴장 기록 설정과 무관하다. 재입장·퇴장·증거 전용 이벤트·이미 알린 출석/지각의 역순 보정은 추가 발송하지 않는다. 알림 저장 실패는 출결·원본 이벤트와 함께 롤백한다.
원문 동일 재전송은 원본 중복 제거. 본문이 달라도 ERP 회의 ID+회의 UUID+Zoom 계정 ID+이벤트 종류+발생 시각이 같으면
DUPLICATE로 출결 이벤트를 추가하지 않는다(같은 시각의 다중 기기도 하나). 회의/수강 행 잠금과 외부 이벤트 키 UNIQUE로 중복 방지.

 * @summary Zoom 원본 기록 출결 재처리
 */
  const reprocessAttendance = (id: number, params?: ReprocessAttendanceParams) => {
    return customInstance<BaseResponseListZoomEventResponse>({ url: `/api/integrations/zoom/meetings/${id}/attendance/reprocess`, method: 'POST', params });
  };
  /**
   * Zoom 리다이렉트 전용. 쿠키/JWT 없이 일회용 state를 검증하고 암호화된 code를 임시 저장합니다. 브라우저 요청은 text/html 응답 body에 인증 안내 화면을 반환합니다. 성공 시 200이며 실제 연결은 아직 완료되지 않은 상태입니다. 실패 시 해당 에러 HTTP 상태와 HTML 안내를 반환합니다. HTML에는 OAuth code/state/completion_key를 포함하지 않습니다. Accept: application/json 요청은 기존처럼 connected=false JSON을 반환합니다(기존 연결 해제 의미 아님). 클라이언트는 시작한 사용자의 JWT와 completion_key로 /oauth/complete를 호출해야 합니다. 만료/재수신/이전 쿠키 방식 state는 ZOOM_INVALID_STATE. 인증 거절 여부는 완료 API에서 확인합니다.
   * @summary Zoom OAuth Callback
   */
  const callback = (params?: CallbackParams) => {
    return customInstance<Callback200>({ url: `/api/integrations/zoom/oauth/callback`, method: 'GET', params });
  };
  /**
   * 생성자 또는 연결 수업의 활성 담당 강사가 DB 설정 스냅샷을 조회합니다. 회차 연결 회의도 포함합니다. 스냅샷이 없는 기존 회의만 최초 조회 시 소유자 토큰으로 동기화합니다. settings_synced_at은 마지막 동기화 시각이며 Zoom 직접 변경은 소유자의 POST /meetings/{id}/sync 후 반영됩니다. password는 생성자 전용, start_url과 토큰은 반환하지 않습니다. 양수 위반은 VALIDATION_ERROR, 접근 불가는 FORBIDDEN, 최초 동기화 실패는 ZOOM_NOT_CONNECTED/ZOOM_AUTHORIZATION_FAILED/ZOOM_API_ERROR입니다.
   * @summary Zoom 회의 설정 조회
   */
  const meeting = (id: number) => {
    return customInstance<BaseResponseZoomMeetingDetailResponse>({ url: `/api/integrations/zoom/meetings/${id}`, method: 'GET' });
  };
  /**
   * id는 ERP 회의 ID이며 양수 필수(VALIDATION_ERROR 400). 생성자와 현재 연결된 Zoom 계정이 모두 일치해야 함(FORBIDDEN). Zoom 회의 전체를 삭제하며 반복 회의도 전체 삭제. Zoom에서 이미 없는 회의(404/3001)도 ERP soft delete 처리. 기존 출결 및 원본 이벤트는 보존하며 삭제된 회의 조회/재삭제는 ZOOM_MEETING_NOT_FOUND. 성공 시 200, data=null. ZOOM_NOT_CONNECTED, ZOOM_AUTHORIZATION_FAILED(재연결 필요), ZOOM_API_ERROR 가능. 외부 호출 실패 시 ERP 회의는 유지하며 재시도 가능.
   * @summary 본인이 생성한 Zoom 회의 삭제
   */
  const deleteMeeting = (id: number) => {
    return customInstance<BaseResponseVoid>({ url: `/api/integrations/zoom/meetings/${id}`, method: 'DELETE' });
  };
  /**
   * ERP ID 오름차순 커서 조회. after_id에 마지막 ID 전달. 이벤트 발생 순서와 수신 순서는 다를 수 있음. attendance_mapping_status와 lesson_session_student_id로 출결 매핑 결과 확인. 매칭 실패는 원본 보존 후 재처리 가능. ZOOM_MEETING_NOT_FOUND 또는 FORBIDDEN.
   * @summary 본인 회의 시작·종료·입퇴장 원본 기록
   */
  const events = (id: number, params?: EventsParams) => {
    return customInstance<BaseResponseListZoomEventResponse>({ url: `/api/integrations/zoom/meetings/${id}/events`, method: 'GET', params });
  };
  /**
   * 연결한 본인 Zoom 계정의 라이선스와 등록 가능 회의 유형·출석 방식을 반환합니다. 등록은 유료 사용자, 유형 2/8, PMI 미사용 조건입니다. 생성 시 다시 검증하며 조직 설정 잠금까지 보장하지 않습니다.
   * @summary Zoom 회의 생성 가능 옵션 조회
   */
  const getOptions = () => {
    return customInstance<BaseResponseZoomCreationOptionsResponse>({ url: `/api/integrations/zoom/meetings/creation-options`, method: 'GET' });
  };
  /**
   * 저장된 연결 상태이며 Zoom 토큰 유효성을 실시간 검사하지 않음. meeting_count는 본인이 현재 연결된 Zoom 계정으로 ERP에서 생성한 삭제되지 않은 회의 수입니다. 수업 미연결 및 종료 회의도 포함하며 Zoom에서 직접 생성한 회의는 제외합니다. 미연결은 0.
   * @summary 본인 Zoom 연결 상태
   */
  const connection = () => {
    return customInstance<BaseResponseZoomConnectionResponse>({ url: `/api/integrations/zoom/connection`, method: 'GET' });
  };
  /**
   * 토큰 폐기 후 저장 토큰을 비우고 인증정보/외부 계정을 soft delete합니다. zoom_user_id/provider_user_id는 삭제용 고유 값으로 변경합니다. 이미 미연결인 경우도 성공합니다. ZOOM_API_ERROR 시 재시도 필요.
   * @summary 본인 Zoom 연결 해제
   */
  const disconnect = () => {
    return customInstance<BaseResponseVoid>({ url: `/api/integrations/zoom/connection`, method: 'DELETE' });
  };
  /**
   * 해당 학원의 활성 ADMIN/STAFF만 조회 가능(ACADEMY_ACCESS_FORBIDDEN). 활성 관리자·직원은 managers, 강사는 instructors로 반환. 미연결 구성원도 포함. 해당 학원 수업/회차에 연결된 ERP 회의만 조회하며 미연결 회의와 삭제된 회의는 제외. 계정 연결 상태와 회의 정보는 DB 저장값이며 Zoom 실시간 조회 아님. meeting_count는 회의 수. lesson_session_id는 해당 학원의 연결 회차 중 최소 ID(수업 공용 회의는 현재 회차 기준). 다른 학원 회차는 제외. academyId 양수 필수(VALIDATION_ERROR 400).
   * @summary 학원 관리자용 Zoom 계정 및 회의 목록
   */
  const get = (academyId: number) => {
    return customInstance<BaseResponseAcademyZoomResponse>({ url: `/api/academies/${academyId}/zoom`, method: 'GET' });
  };
  return {
    bindLessonSessions,
    bindLessonSession,
    receive,
    complete,
    authorize,
    create,
    deleteMeetings,
    sync,
    start,
    reprocessAttendance,
    callback,
    meeting,
    deleteMeeting,
    events,
    getOptions,
    connection,
    disconnect,
    get,
  };
};
export type BindLessonSessionsResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getZoom>['bindLessonSessions']>>>;
export type BindLessonSessionResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getZoom>['bindLessonSession']>>>;
export type ReceiveResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getZoom>['receive']>>>;
export type CompleteResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getZoom>['complete']>>>;
export type AuthorizeResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getZoom>['authorize']>>>;
export type CreateResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getZoom>['create']>>>;
export type DeleteMeetingsResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getZoom>['deleteMeetings']>>>;
export type SyncResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getZoom>['sync']>>>;
export type StartResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getZoom>['start']>>>;
export type ReprocessAttendanceResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getZoom>['reprocessAttendance']>>>;
export type CallbackResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getZoom>['callback']>>>;
export type MeetingResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getZoom>['meeting']>>>;
export type DeleteMeetingResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getZoom>['deleteMeeting']>>>;
export type EventsResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getZoom>['events']>>>;
export type GetOptionsResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getZoom>['getOptions']>>>;
export type ConnectionResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getZoom>['connection']>>>;
export type DisconnectResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getZoom>['disconnect']>>>;
export type GetResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getZoom>['get']>>>;
